import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function CheckoutPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const cart = location.state?.cart || [];

  const [address, setAddress] = useState({ name: "", email: "", phone: "", street: "", city: "", state: "", zip: "" });
  const [errors, setErrors] = useState({});
  const [payment, setPayment] = useState("cod");
  const [placingOrder, setPlacingOrder] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  const validate = () => {
    const errs = {};
    if (!address.name.trim()) errs.name = "Name is required";
    if (!address.email.trim()) errs.email = "Email is required";
    if (!address.phone.trim()) errs.phone = "Phone number is required";
    if (!address.street.trim()) errs.street = "Street address is required";
    if (!address.city.trim()) errs.city = "City is required";
    if (!address.state.trim()) errs.state = "State is required";
    if (!address.zip.trim()) errs.zip = "ZIP code is required";
    return errs;
  };

  const handleAddressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: undefined });
  };

  const handleOrder = async (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    setPlacingOrder(true);

    try {
      await fetch("http://localhost:5000/api/order", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ address, cart, total, payment }) });
      setPlacingOrder(false);
      setShowSuccess(true);
    } catch {
      setPlacingOrder(false);
      alert("Failed to send order. Please try again.");
    }
  };

  const handleCloseModal = () => { setShowSuccess(false); navigate("/store"); };

  if (!cart.length) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-xl shadow-lg text-center">
        <h2 className="text-2xl font-bold mb-4 text-blue-700">No items in cart</h2>
        <button className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold shadow hover:bg-blue-700 transition" onClick={() => navigate("/store")}>Go to Store</button>
      </div>
    </div>
  );

  return (
    <div className="bg-gray-50 min-h-screen pt-24 px-2 md:px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl p-6 md:p-10">
        <h1 className="text-3xl font-extrabold text-blue-700 mb-8 text-center tracking-tight">Checkout</h1>
        <form onSubmit={handleOrder} className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-blue-50 rounded-xl p-6 shadow flex-1">
            <div className="flex items-center gap-2 mb-4"><img src="https://img.icons8.com/color/32/address--v1.png" alt="address" /><h2 className="font-bold text-lg text-blue-700">Shipping Address</h2></div>
            <div className="space-y-2">
              <input name="name" value={address.name} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.name ? 'border-red-400':'border-gray-300'}`} placeholder="Full Name" required />
              <input name="email" type="email" value={address.email} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.email ? 'border-red-400':'border-gray-300'}`} placeholder="Email" required />
              <input name="phone" value={address.phone} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.phone ? 'border-red-400':'border-gray-300'}`} placeholder="Phone Number" required />
              <input name="street" value={address.street} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.street ? 'border-red-400':'border-gray-300'}`} placeholder="Street Address" required />
              <div className="flex gap-2"><input name="city" value={address.city} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.city ? 'border-red-400':'border-gray-300'}`} placeholder="City" required /><input name="state" value={address.state} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.state ? 'border-red-400':'border-gray-300'}`} placeholder="State" required /></div>
              <input name="zip" value={address.zip} onChange={handleAddressChange} className={`w-full border rounded-lg px-4 py-2 ${errors.zip ? 'border-red-400':'border-gray-300'}`} placeholder="ZIP Code" required />
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="bg-gray-50 rounded-xl p-6 shadow">
              <div className="flex items-center gap-2 mb-4"><img src="https://img.icons8.com/color/32/receipt-approved.png" alt="summary" /><h2 className="font-bold text-lg text-blue-700">Order Summary</h2></div>
              <ul className="divide-y divide-gray-200 mb-4">
                {cart.map(item => <li key={item.id} className="flex justify-between py-2"><span className="font-medium text-gray-700">{item.name} <span className="text-xs text-gray-400">x{item.qty}</span></span><span className="font-semibold text-gray-800">₹{item.price*item.qty}</span></li>)}
              </ul>
              <div className="flex justify-between items-center border-t pt-3 mt-3"><span className="font-bold text-lg text-blue-700">Total</span><span className="font-bold text-lg text-blue-700">₹{total}</span></div>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 shadow">
              <div className="flex items-center gap-2 mb-4"><img src="https://img.icons8.com/color/32/card-in-use.png" alt="payment" /><h2 className="font-bold text-lg text-blue-700">Payment Method</h2></div>
              <div className="space-y-3"><label className="flex items-center gap-2 cursor-pointer"><input type="radio" name="payment" value="cod" checked={payment==="cod"} onChange={()=>setPayment('cod')} /> <span>Cash on Delivery</span></label><label className="flex items-center gap-2 cursor-pointer"><input type="radio" name="payment" value="upi" checked={payment==="upi"} onChange={()=>setPayment('upi')} /><span>UPI / Online Payment (Demo)</span></label></div>
              <button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded-lg font-bold w-full mt-6 shadow hover:bg-blue-700 transition" disabled={placingOrder}>{placingOrder ? "Placing Order..." : "Place Order"}</button>
            </div>
          </div>
        </form>
      </div>

      {showSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full text-center relative">
            <button className="absolute top-2 right-4 text-2xl text-gray-400 hover:text-gray-600" onClick={handleCloseModal} aria-label="Close">×</button>
            <div className="flex flex-col items-center">
              <img src="https://img.icons8.com/color/96/ok--v1.png" alt="Success" className="w-20 h-20 mb-4" />
              <h2 className="text-2xl font-bold mb-2 text-green-600">Order Placed!</h2>
              <p className="mb-4 text-gray-700">Your order was placed successfully.<br/>A receipt has been sent to your email.</p>
              <button className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition" onClick={handleCloseModal}>Go to Home</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CheckoutPage;
